import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { filter, take } from 'rxjs/operators';
import { AuctionItemState, LaunchDarklyService } from 'remarketing-angular-library';

@Injectable({
  providedIn: 'root'
})
export class SharedlistsService {
  constructor(
    private readonly launchDarklyService: LaunchDarklyService,
    private readonly store: Store
  ) {}

  getShareListVehicles(): string {
    let offerListTooltipBody = '';
    this.store
      .select(AuctionItemState.auctionItem)
      .pipe(
        filter(val => !!val),
        take(1)
      )
      .subscribe(response => {
        offerListTooltipBody = this.offerListTooltipBody(response.offerLists);
      });

    return offerListTooltipBody;
  }

  offerListTooltipBody(offerLists): string {
    return offerLists?.map(item => {
      const classList = this.isInServiceVehiclesEnabled ? 'd-block tooltip-offer-link' : 'd-block';
      const dealershipName = item.dealershipName ? ` - ${item.dealershipName}` : '';
      return `<a class='${classList}' href='/ui/offer-list/${item.offerListUuid}'>${item.name}${dealershipName}</a>`;
    }).join('') ?? '';
  }

  offerListsTooltip(offerListTooltipTitle, offerListTooltipBody) {
    return { title: offerListTooltipTitle, body: offerListTooltipBody };
  }

  isOfferListsTooltipBodyEmpty(offerListTooltipBody): boolean {
    return !offerListTooltipBody?.length;
  }

  get isInServiceVehiclesEnabled(): boolean {
    return this.launchDarklyService.getFeatureFlag('platform-inServiceVehiclesEnabled', false);
  }
}
